<div class="list-timeline__header">
  <ng-container #headerPlaceholder>
    <ng-content select="[header]"></ng-content>
  </ng-container>
  <ng-container *ngIf="!headerPlaceholder?.childNodes?.length">
    <ng-container *ngTemplateOutlet="headerDefaultTemplate"></ng-container>
  </ng-container>
</div>

<div class="list-timeline__body">
  <div class="scrollable scrollable--y">
    <div class="flex column justify-center align-center text-400" *ngIf="!orders?.length">
      <app-icon name="route"></app-icon>

      <span class="text-300">{{'templates.OrdersTemplate.NoOrdersAddedYet' | translate}}</span>
    </div>

    <ng-container *ngIf="sortable">
      <div cdkDropList (cdkDropListDropped)="dropOrder.emit($event)">
        <ng-container *ngFor="let order of orders; let i = index;">
          <div class="list-timeline__item px-3 brd-l-1 brd-solid brd-200" *ngIf="order.orderLineStatus !== OrderLineStatus.Delivered" cdkDrag>
            <ng-container *ngTemplateOutlet="orderListItemTemplate; context: { $implicit: order, index: i, sortable: true }"></ng-container>
          </div>
          <div
            class="list-timeline__item px-3 brd-l-1 brd-solid brd-200 list-timeline__item--primary"
            *ngIf="order.orderLineStatus === OrderLineStatus.Delivered"
          >
            <ng-container *ngTemplateOutlet="orderListItemTemplate; context: { $implicit: order, index: i, sortable: false }"></ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="!sortable">
      <div class="list-timeline__item px-3 brd-l-1 brd-solid brd-200" *ngFor="let order of orders; let i = index;">
        <ng-container *ngTemplateOutlet="orderListItemTemplate; context: { $implicit: order, index: i }"></ng-container>
      </div>
    </ng-container>
  </div>
</div>

<!-- templates -->
<ng-template #headerDefaultTemplate>
  <div class="bg-100 px-3 py-2 radius-1 flex justify-space-between small">
    <div class="flex align-center text-400">
      <app-icon class="align-middle text-accent" name="warehouse"></app-icon>
      <div class="mx-3">
        <span>{{city}} {{location ? '- ' + location : ''}} {{gate ? '- ' + gate : ''}}</span>
      </div>
      <app-rect-tag color="success" size="xs" theme="dashed" *ngIf="checkInDate">
        {{'shipments.Table.CheckedIn' | translate}}: {{checkInDate | date:'medium'}}
      </app-rect-tag>
    </div>
    <div [ngClass]="consumedCapacity >= totalCapacity ? 'text-warn' : 'text-400'" class="flex align-center">
      <app-icon size="xs" name="group" class="mr-1"></app-icon>
      {{consumedCapacity}} / {{totalCapacity || 0}}
    </div>
  </div>
</ng-template>

<ng-template #orderListItemTemplate let-order let-index="index" let-drag="sortable">
  <app-orders-list-item
    [showOrderType]="showOrderType"
    [readonly]="readonly"
    [timeline]="timeline"
    [totalCount]="order.actualNoOfPallets || order.noOfPallets"
    [totalItemsCount]="order.actualNoOfItems||order.noOfItems"
    [index]="index + 1"
    [lastIndex]="orders.length"
    [orderType]="order.isPalletDetails ? 'detailed' : 'undetailed'"
    [order]="order"
    [pallets]="order.pallets"
    [actionIcon]="actionIcon"
    (expandPallets)="getOrderPallets(order)"
    (selectQuantity)="handelRemoveOrder({ order: order, index})"
  >
    <app-icon *ngIf="drag" class="cursor-drag" name="linear-menu" action-suffix></app-icon>
  </app-orders-list-item>
</ng-template>
